const API_DIR_THEME_VAR = {
    COLOR: {
        PRIMARY: '--api-dir-pkg-primary-colour',
        SECONDARY: '--api-dir-pkg-secondary-colour'
    },
    FONT: {
        PRIMARY: '--api-dir-pkg-primary-font',
        SECONDARY: '--api-dir-pkg-secondary-font'
    }
};

const API_DIRECTORY_THEME = {
    DEALER_API_DIRECTORY: "dealerApiDirectory",
    ISV_API_DIRECTORY: "isvApiDirectory",
};

const THEME_COLORS = {
    [API_DIRECTORY_THEME.DEALER_API_DIRECTORY]: {
        primary: "#196FE1",
        secondary: "#E8F1FC",
    },
    [API_DIRECTORY_THEME.ISV_API_DIRECTORY]: {
        primary: "#6b2574",
        secondary: "#f0e9f1",
    },
};

const THEME_FONTS = {
    [API_DIRECTORY_THEME.DEALER_API_DIRECTORY]: {
        primary: "Roboto",
        secondary: "Roboto",
    },
    [API_DIRECTORY_THEME.ISV_API_DIRECTORY]: {
        primary: "Montserrat",
        secondary: "Open Sans",
    },
}

const API_DIRECTORY_PAGE = {
    HOME: 'apiDirHome',
    DETAILS: 'apiDetails'
}

const API_TYPES = {
    REST: "api",
    ASYNC: "async-api",
    PROVIDER_ID_PREFIX: "api-v2",
    BUNDLE: "bundle"
};

const SEARCH_FILTER_URL_PARAMS = {
    filters: 'Group',
    apiType: 'Type',
    category: 'Category'
  };

const FILTER_QUERY_PARAMS = {
  TYPE: 'Type',
  CATEGORY: 'Category',
  GROUP: 'Group',
};

const FILTER_ACTIONS = {
  ADDED: 'added',
  REMOVED: 'removed',
};

const API_TYPE_MAPPING = {
    restApi: 'REST',
    asyncApi: 'Async'
  };

const API_TYPE_TO_PARAMS_MAP = {
    REST: 'restApi',
    Async: 'asyncApi'
  };

const API_DETAILS_HANDLERS_MODEL = {
    apiTypeFilter: (type) => { alert(JSON.stringify(type)) },
    apiCategoryFilter: (category) => { alert(JSON.stringify(category)) },
    sendEmailToConsumer: (payload) => { alert(JSON.stringify(payload)) },
    sendEmailToProvider: (payload) => { alert(JSON.stringify(payload)) },
    addToCart: (apiDetails) => { alert(JSON.stringify(apiDetails)) },
    buildWithApi: (apiDetails) => { alert(JSON.stringify(apiDetails)) },
    openMyCart: () => { },
    viewInMyAPIs: () => { },
    selectPricingPlan: () => { }
}

const EMAIL_MESSAGE = {
    SUCCESS: 'Message Sent.',
    FAILURE: 'Message Could not be sent.',
    SENDING: 'sending'
}
const ADD_API_To_CART_FAILURE_MESSAGE='Failed to add API to the cart! Try again after sometime.'

const ORDER_APIS_STEPPER_FOOTER = {
    REVIEW_APIS: 'Review Apis',
    CONFIGURE_FIELDS: 'Configure Fields',
    CONFIGURE_CMF: 'Configure CMF',
    SELECTED_PRICING: 'Selected Pricing',
    REVIEW_TERMS: 'Review Terms'

}

const DUMMY_WEBHOOK_URL = "https://fortellis.io"

const API_TYPES_OPTIONS = {
    REST: "REST",
    ASYNC: "Async",
};

export {
    API_DIRECTORY_THEME,
    THEME_COLORS,
    API_DIRECTORY_PAGE,
    API_DIR_THEME_VAR,
    API_TYPES,
    API_DETAILS_HANDLERS_MODEL,
    EMAIL_MESSAGE,
    ORDER_APIS_STEPPER_FOOTER,
    THEME_FONTS,
    ADD_API_To_CART_FAILURE_MESSAGE,
    DUMMY_WEBHOOK_URL,
    API_TYPES_OPTIONS,
    SEARCH_FILTER_URL_PARAMS,
    API_TYPE_MAPPING,
    API_TYPE_TO_PARAMS_MAP,
    FILTER_QUERY_PARAMS,
    FILTER_ACTIONS,
}
